// Utility function to generate URL-friendly slugs from titles
export const generateSlug = (title) => {
  if (!title) return '';
  
  return title
    .toLowerCase()
    .trim()
    .replace(/[^\w\s-]/g, '') // Remove special characters except spaces and hyphens
    .replace(/\s+/g, '-') // Replace spaces with hyphens
    .replace(/-+/g, '-') // Replace multiple hyphens with single hyphen
    .replace(/^-|-$/g, ''); // Remove leading/trailing hyphens
};

// Function to generate unique slug by checking for duplicates
export const generateUniqueSlug = async (title, collection, existingId = null) => {
  const baseSlug = generateSlug(title);
  let slug = baseSlug;
  let counter = 1;
  
  // Import Firebase functions dynamically to avoid circular imports
  const { collection: firestoreCollection, query, where, getDocs, db } = await import('../services/firebase');
  
  while (true) {
    // Check if slug already exists
    const q = query(
      firestoreCollection(db, collection),
      where('slug', '==', slug)
    );
    
    const snapshot = await getDocs(q);
    const existingDocs = snapshot.docs.filter(doc => doc.id !== existingId);
    
    if (existingDocs.length === 0) {
      return slug;
    }
    
    // If slug exists, try with counter
    slug = `${baseSlug}-${counter}`;
    counter++;
  }
};

// Function to find document by slug
export const findDocumentBySlug = async (slug, collection) => {
  const { collection: firestoreCollection, query, where, getDocs, db } = await import('../services/firebase');
  
  const q = query(
    firestoreCollection(db, collection),
    where('slug', '==', slug)
  );
  
  const snapshot = await getDocs(q);
  
  if (snapshot.empty) {
    return null;
  }
  
  return {
    id: snapshot.docs[0].id,
    ...snapshot.docs[0].data()
  };
};
